import { api } from '@/services'

import {
  create,
  show,
  update,
  listActiveServiceTypes
} from '@/services/customer/customerService'

import {
  getSignedUrl,
  uploadToS3,
} from '@/services/upload/uploadService'

// for some reason, this action do not work inside the module
// TODO: add this action to the module
async function customerLogoUpload(payload) {
  try {
    await getSignedUrl({
      filename: payload.file.name,
      filetype: payload.file.type,
      real_estate_id: payload.realEstateId,
    }, '/admin/realEstate/logoUploadURL')
      .then(async ({ signedUrl, external_filename}) => {
        await uploadToS3(signedUrl, payload.file)
          .then(() => {
            const attachData = {
              external_filename: external_filename,
              external_url: signedUrl.substring(0, signedUrl.indexOf('?')),
              filename: payload.file.name,
              real_estate_id: payload.realEstateId,
            }

            return attachData
          })
          .then(async (attachData) => { await api.post('admin/realEstate/addLogo ', attachData) })
          .catch((error) => { console.log(error) })
        })
      .catch((error) => { console.log(error) })
  } catch (errors) {
    return errors
  }
}

const qs = require('qs')

const state = {
  customer: {},
  customers: [],
  asaasCustomers: [],
  activeServiceTypes: [],
  isCustomerLoading: false,
  isCustomersLoading: false,
  isActiveServiceTypesLoading: false,
}

const getters = {
  customer: (state) => state.customer,
  customers: (state) => state.customers,
  asaasCustomers: (state) => state.asaasCustomers,
  activeServiceTypes: (state) => state.activeServiceTypes,
  isCustomerLoading: (state) => state.isCustomerLoading,
  isCustomersLoading: (state) => state.isCustomersLoading,
  isActiveServiceTypesLoading: (state) => state.isActiveServiceTypesLoading,
}

const actions = {
  async fetchCustomers({ commit, dispatch, rootState }, search) {
    commit('setIsLoading', true)

    const defaultParams = {
      size: rootState.paginate.itemsPerPage,
      page: rootState.paginate.currentPage - 1,
    }

    if (search) {
      defaultParams.search = search
    }

    const params = { ...defaultParams, ...rootState.filters.filters }

    api
      .get('admin/realEstate/search', {
        params: params,
        paramsSerializer: (params) => {
          return qs.stringify(params, { arrayFormat: 'repeat' })
        },
      })
      .then(({ data }) => {
        const { result, total } = data

        commit('setCustomers', result)
        commit('setTotalPages', total)
      })
      .catch(({ data }) => {
        dispatch('showErrorMessage', data.message)
      })
      .finally(() => {
        commit('setIsLoading', false)
      })
  },

  async searchCustomers({ commit, dispatch, rootState }, search) {
    commit('setIsCustomersLoading', true)

    const defaultParams = {
      size: rootState.paginate.itemsPerPage,
    }

    const params = { search }

    api
      .get('admin/realEstate/search', { params, ...defaultParams })
      .then(({ data }) => {
        const { result, total } = data

        commit('setCustomers', result)
        commit('setTotalPages', total)
      })
      .catch(({ data }) => {
        dispatch('showErrorMessage', data.message)
      })
      .finally(() => {
        commit('setIsCustomersLoading', false)
      })
  },

  async fetchAsaasCustomers({ commit, dispatch, rootState }) {
    commit('setIsLoading', true)

    const defaultParams = {
      size: rootState.paginate.itemsPerPage,
      page: rootState.paginate.currentPage - 1,
    }

    const params = { ...defaultParams, ...rootState.filters.filters }

    try {
      const { data } = await api.get('admin/asaas/listCustomers', {
        params,
      })

      commit('setAsaasCustomers', data.result)
    } catch (error) {
      dispatch('showErrorMessage', error.message)
    } finally {
      commit('setIsLoading', false)
    }
  },

  async linkAsaasCustomer({ commit, dispatch }, linkAsaasCustomer) {
    const { asaasCustomerId, realEstateId } = linkAsaasCustomer

    commit('setIsLoading', true)

    try {
      await api.post('admin/asaas/linkAsaasCustomer', {
        real_estate_id: realEstateId,
        asaas_customer_id: asaasCustomerId,
      })

      commit('setFilters', { search: '' })
      commit('closeAllModals')
      dispatch('fetchCustomers')
      dispatch('showSuccessMessage', 'Conta vinculada com sucesso')
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsLoading', false)
    }
  },

  async removeLinkAsaasCustomer({ commit, dispatch }, realEstateId) {
    commit('setIsLoading', true)

    try {
      await api.post('admin/asaas/unlinkAsaasCustomer', {
        real_estate_id: realEstateId,
      })

      commit('setFilters', { search: '' })
      commit('closeAllModals')
      dispatch('fetchCustomers')
      dispatch('showSuccessMessage', 'Vínculo removido com sucesso')
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsLoading', false)
    }
  },

  async addDefaultContract({ commit, dispatch }, body) {
    commit('setIsLoading', true)

    try {
      await api.put('admin/realEstate/updateDefaultContract', body)
      dispatch('fetchCustomers')
      dispatch(
        'showSuccessMessage',
        'Contratos padrão adicionados com sucesso!'
      )
      commit('closeModal', 'ADD_DEFAULT_CONTRACT_MODAL')
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsLoading', false)
    }
  },

  async linkVendors({ commit, dispatch }, body) {
    commit('setIsLoading', true)

    try {
      await api.post('admin/realEstate/linkVendors', body)
      dispatch('fetchCustomers')
      dispatch('showSuccessMessage', 'Fornecedores vinculados com sucesso!')
      commit('closeModal', 'CUSTOMER_LINK_VENDORS_MODAL')
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsLoading', false)
    }
  },

  async createCustomer(state, body) {
    return create(body)
      .then(async ({ data }) => {
        const payload = {
          realEstateId: data.id,
          file: body.logo,
        }

        if (payload.file) await customerLogoUpload(payload)
      })
  },

  async updateCustomer(state, body) {
    return update(body)
      .then(async ({ data }) => {
        const payload = {
          realEstateId: data.id,
          file: body.logo,
        }

        if (payload.file) await customerLogoUpload(payload)
      })
  },

  async fetchCustomer({ commit, dispatch }, realEstateId) {
    commit('setCustomer', {})
    commit('setIsLoading', true)
    commit('setIsCustomerLoading', true)

    try {
      const { data } = await show(realEstateId)
      commit('setCustomer', data)
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsLoading', false)
      commit('setIsCustomerLoading', false)
    }
  },

  async fetchActiveServiceTypes({ commit, dispatch }, realEstateId) {
    try {
      commit('setIsActiveServiceTypesLoading', true)
      const { data } = await listActiveServiceTypes(realEstateId)
      commit('setActiveServiceTypes', data)
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsActiveServiceTypesLoading', false)
    }
  },
}

const mutations = {
  setCustomers: (state, customers) => {
    state.customers = customers
  },

  setCustomer: (state, customer) => {
    state.customer = customer
  },

  setAsaasCustomers: (state, customers) => {
    state.asaasCustomers = customers
  },

  setActiveServiceTypes: (state, activeServiceTypes) => {
    state.activeServiceTypes = activeServiceTypes
  },

  setIsCustomerLoading: (state, status) => {
    state.isCustomerLoading = status
  },

  setIsCustomersLoading: (state, status) => {
    state.isCustomersLoading = status
  },

  setIsActiveServiceTypesLoading: (state, status) => {
    state.isActiveServiceTypesLoading = status
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
